// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b6cd3756","453":"143dd6cf","455":"5a2a48f9","946":"c9a6e773"}[chunkId] + ".chunk.js";
};